import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { TruckTypeWithoutIdDTO } from '@api/ringil-api.v2.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import SvgTrucktype from '@components/ringil3/icons/Trucktype.tsx';
import { useLovTruckTypes } from '@hooks/customer.hooks.tsx';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { stampPrimeDropdownOverlayTestIds } from '@utils/testUtils';

interface ComponentProps {
  secured?: SecuredConfig;
  truckTypeCode?: string;
  onChange: (truckTypeCode: string) => void;
  readOnly?: boolean;
}

const TruckTag: React.FC<ComponentProps> = ({ secured, truckTypeCode, onChange, readOnly = false }) => {
  const { tr } = useTranslationLgs();
  // Shared codebook: whoever asks first loads it, everyone else on the page reuses that answer.
  const options = useLovTruckTypes();
  const [internalValue, setInternalValue] = useState(truckTypeCode);

  const listTestId = 'expeditionInfo-typeOfCarList';

  const applyOverlayTestIds = () => stampPrimeDropdownOverlayTestIds(listTestId);

  const formatValue = (code: string) => {
    const item = options?.find(i => i.code === code);
    return item ? item.name : null;
  };

  return (
    <>
      <ButtonTag
        secured={secured}
        label={tr('TruckTag.typAutomobilu', 'Typ automobilu')}
        value={formatValue(truckTypeCode)}
        icon={<SvgTrucktype />}
        onSave={onSuccess => {
          onSuccess();
          onChange(internalValue);
        }}
        readonly={readOnly}
        autoClose
        dataTestId="expeditionInfo-typeOfCar"
      >
        <div data-testid={listTestId}>
          <Dropdown
            className="w-full"
            options={options}
            value={internalValue}
            optionLabel={'name'}
            optionValue={'code'}
            panelClassName="expeditionInfoDropdownPanel"
            onShow={() => {
              requestAnimationFrame(applyOverlayTestIds);
            }}
            itemTemplate={(option: TruckTypeWithoutIdDTO) => <div>{option.name}</div>}
            onChange={e => setInternalValue(e.target.value)}
          />
        </div>
      </ButtonTag>
    </>
  );
};

export default TruckTag;
